var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1921 3.13148C10.4711 2.38788 9.20625 1.69214 7 1.69214C4.79375 1.69214 3.5289 2.38788 2.80794 3.13148C2.04814 3.91514 1.75 4.8981 1.75 5.64046C1.75 7.14904 2.60663 9.22955 3.88969 11.4027C4.91689 13.1425 6.10542 14.7593 7 15.8987C7.89457 14.7593 9.08311 13.1425 10.1103 11.4027C11.3934 9.22955 12.25 7.14904 12.25 5.64046C12.25 4.8981 11.9519 3.91514 11.1921 3.13148ZM14 5.64046C14 3.38428 12.25 0 7 0C1.75 0 0 3.38428 0 5.64046C0 9.60644 4.27253 15.2938 6.14171 17.5922C6.58396 18.136 7.41604 18.136 7.85829 17.5922C9.72747 15.2938 14 9.60644 14 5.64046Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 6.76855C10.5 8.63764 8.933 10.1528 7 10.1528C5.067 10.1528 3.5 8.63764 3.5 6.76855C3.5 4.89947 5.067 3.38428 7 3.38428C8.933 3.38428 10.5 4.89947 10.5 6.76855ZM7 8.46069C7.9665 8.46069 8.75 7.70309 8.75 6.76855C8.75 5.83401 7.9665 5.07641 7 5.07641C6.0335 5.07641 5.25 5.83401 5.25 6.76855C5.25 7.70309 6.0335 8.46069 7 8.46069Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.72e135b11b82e37365a29b60b69bcbd0.svg";
export { ForwardRef as ReactComponent };